// import Axios from "axios";
// export const imageToBase64 = function (imageUrl) {
//     // 判断环境
//     if (process.env.NODE_ENV === 'development') {
//         imageUrl = imageUrl.replace('http://hs-algo-public-read-sit.tos-cn-shanghai.volces.com', '/downloadImg');
//     }
//     console.log('imageUrl', imageUrl)
//     return fetch(imageUrl)
//       .then(response => response.blob())
//       .then(blob => new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.onload = () => resolve(reader.result);
//         reader.onerror = error => reject(error);
//         reader.readAsDataURL(blob);
//       }));
//   }

  export const imageToBase64 = async function(url) {
    try {
      const response = await fetch(url, { redirect: 'follow' }); // 设置 redirect 选项为 'follow'
      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.statusText}`);
      }

      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching or converting image:', error);
      throw error;
    }
  }

// 用Axios实现上面的方法

// import axios from 'axios';

// export const imageToBase64 = async function (imageUrl) {
//     // Check the environment and modify the URL if needed.
//     if (process.env.NODE_ENV === 'development') {
//         imageUrl = imageUrl.replace('http://hs-algo-public-read-sit.tos-cn-shanghai.volces.com', '/downloadImg');
//     }

//     console.log('imageUrl', imageUrl);

//     try {
//         // Use Axios to fetch the image.
//         const response = await axios({
//             url: imageUrl,
//             method: 'get',
//             responseType: 'blob' // important!
//         });

//         // Convert the Blob to a base64 encoded string.
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 let result = reader.result;
//                 if (result) {
//                     resolve(result);
//                 } else {
//                     reject(new Error('Error converting blob to base64'));
//                 }
//             };
//             reader.onerror = error => reject(error);
//             reader.readAsDataURL(response.data);
//         });
//     } catch (error) {
//         console.error('Error fetching image:', error);
//         throw error;
//     }
// };
